Librarian.Modules.TagCloud = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onDataLoaded", "drawCloud", "onKeywordClicked"],

    options: {
        classPrefix: "modules-tagcloud-",
        method: "getTopKeywordsForLibrary",
        methodOptions: null,
        onTagCloudLoaded: null,
        maxKeywordsSelected: 1
    },

    data: null,
    url: null,
    svg: null,

    tagCloudMethods: {
        getTopKeywordsForLibrary: {
            page: "default",
            method: "getltck",          
            options: {
                max: 20,
                all: false
            }
        },

        getTopKeywordsForCategory: {
            page: "default",
            method: "getctck",
            options: {
                cid: -1,
                recursive: false,
                max: 20,
                all: false
            }
        },

        getTopKeywordsForFile: {
            page: "default",
            method: "getftck",
            options: {
                fid: -1,
                max: 20,
                all: false
            }
        },

        getTopKeywordsForSlide: {
            page: "default",
            method: "getstck",
            options: {
                sid: -1,
                max: 20,
                all: false
            }
        },

        getOpportunityTopKeywords: {
            page: "crm",
            method: "getotck",
            options: {
                oppId: -1,
                crmType: Librarian.crmType.undefined,
                max: 20,
                all: false
            }
        }
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);

        var method = this.tagCloudMethods[this.options.method];
        method.options = Object.merge({}, method.options, this.options.methodOptions);
        this.url = this.getApiUrl(method.page, method.method, method.options);

        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        new Librarian.Request.JSON({
            url: this.url,
            onSuccess: this.onDataLoaded,
            onFailure: Librarian.Utils.onFailure
        }).send();
    },

    onDataLoaded: function (data) {
        this.data = data;
        var maxScore = Math.max.apply(Math, data.map(function(tag) {
            return tag.totalScore;
        }));
        var maxFontSize = 100;

 
        var layout = d3.layout.cloud()
            .size([500, 500])
            .words(data.map(function (tag) {
                  return { text: tag.keyword, size: (tag.totalScore / maxScore) * maxFontSize};
              }))
            .padding(5)
            .rotate(0)
            .font("Lato")
            .fontSize(function (d) { return d.size; })
            .on("end", function(words) {
                this.drawCloud(layout, words);
            }.bind(this));

        layout.start();
    },

    drawCloud: function(layout, words) {
        d3.select(this.containerEl).append("svg")
            .attr("width", layout.size()[0])
            .attr("height", layout.size()[1])
          .append("g")
            .attr("transform", "translate(" + layout.size()[0] / 2 + "," + layout.size()[1] / 2 + ")")
          .selectAll("text")
            .data(words)
          .enter().append("text")
            .style("font-size", function (d) { return d.size + "px"; })
            .attr("text-anchor", "middle")
            .attr("transform", function (d) {
                return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
            })
            .text(function (d) { return d.text; });

        if (this.options.onTagCloudLoaded && typeOf(this.options.onTagCloudLoaded) === "function") {
            this.options.onTagCloudLoaded(this.data);
        }

        this.containerEl.getElements("text").addOnClick(this.onKeywordClicked);
        this.containerEl.show();
    },

    onKeywordClicked: function (e) {
        var keywordEl = $(e.target);
        var classList = (keywordEl.getAttribute("class") || "").split(/\s+/g);

        if (classList.contains("selected")) {
            this.onKeyWordDeselected(keywordEl);          
        } else {
            this.onKeywordSelected(keywordEl);
        }
    },

    onKeywordSelected: function(keywordEl) {      
        var currentlySelected = this.containerEl.getElements("text.selected");
        if (currentlySelected.length >= this.options.maxKeywordsSelected) {
            currentlySelected.each(function (el) {
                var classList = (el.getAttribute("class") || "").split(/\s+/g);
                classList.erase("selected");
                el.setAttribute("class", classList.join(" "));
            });
        }

        var keywordClassList = (keywordEl.getAttribute("class") || "").split(/\s+/g);
        keywordClassList.push("selected");
        keywordEl.setAttribute("class", keywordClassList.join(" "));

        var selectedKeywords = this.containerEl.getElements("text.selected").map(function(el) {
            return el.get("text");
        });

        if (this.options.onKeywordSelected && typeOf(this.options.onKeywordSelected) === "function") {
            this.options.onKeywordSelected(keywordEl.get("text"), selectedKeywords);
        }
    },

    onKeyWordDeselected: function (keywordEl) {
        var keywordClassList = (keywordEl.getAttribute("class") || "").split(/\s+/g);
        keywordClassList.erase("selected");
        keywordEl.setAttribute("class", keywordClassList.join(" "));

        var selectedKeywords = this.containerEl.getElements("text.selected").map(function (el) {
            return el.get("text");
        });

        if (this.options.onKeywordDeselected && typeOf(this.options.onKeywordDeselected === "function")) {
            this.options.onKeywordDeselected(keywordEl.get("text"), selectedKeywords);
        }
    },

    encodeQueryData: function(data) {
        var ret = [];
        for (var d in data)
            ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
        return ret.join("&");
    },

    getApiUrl: function (page, method, options) {
        var url;
        if (page == "crm") {
            url = Librarian.path.getCrmUrl(method);
        } else {
            url = Librarian.path.getMethodUrl(method);
        }

        url += "&out=cjson";
        var params = this.encodeQueryData(options);

        if (params) {
            url += "&" + params;
        }

        return url;
    }
});